import React from 'react';
import { FileTextIcon, UsersIcon, HandshakeIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function MechanismReveal() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-light py-16 md:py-24 border-y border-white/5" data-id="element-209">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-210">
        <div className="space-y-6 text-gray-200" data-id="element-211">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4" data-id="element-212">
            Por Qué Sigue Pasando Esto — La Verdad
          </h2>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-213">
            El IRS no es tu enemigo en el sentido que crees. Es un sistema. Un
            sistema enorme, frío, y sin emoción.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-214">
            Y como todo sistema... tiene reglas.
          </p>

          <div className="space-y-4 my-8" data-id="element-215">
            <div className="flex items-start gap-4" data-id="element-216">
              <div className="bg-navy-dark p-3 rounded-lg border border-white/5 flex-shrink-0" data-id="element-217">
                <FileTextIcon className="w-6 h-6 text-gold-primary" data-id="element-218" />
              </div>
              <p className="text-lg md:text-xl text-gray-300" data-id="element-219">
                Reglas que permiten enmendar declaraciones pasadas.
              </p>
            </div>

            <div className="flex items-start gap-4" data-id="element-220">
              <div className="bg-navy-dark p-3 rounded-lg border border-white/5 flex-shrink-0" data-id="element-221">
                <UsersIcon className="w-6 h-6 text-gold-primary" data-id="element-222" />
              </div>
              <p className="text-lg md:text-xl text-gray-300" data-id="element-223">
                Reglas que reconocen dependientes bajo ciertas condiciones.
              </p>
            </div>

            <div className="flex items-start gap-4" data-id="element-224">
              <div className="bg-navy-dark p-3 rounded-lg border border-white/5 flex-shrink-0" data-id="element-225">
                <HandshakeIcon className="w-6 h-6 text-gold-primary" data-id="element-226" />
              </div>
              <p className="text-lg md:text-xl text-gray-300" data-id="element-227">
                Reglas que permiten acuerdos de pago que tú puedes usar
                estratégicamente.
              </p>
            </div>
          </div>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-228">
            Estas reglas existen. Son legales. Son accesibles.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-229">
            Pero funcionan como una puerta cerrada: están ahí, pero tienes que
            saber que existen y tienes que tocarlas.
          </p>

          <div className="bg-gradient-to-br from-gold-primary/15 to-navy-dark p-1 rounded-xl my-8" data-id="element-230">
            <div className="bg-navy-dark p-6 md:p-8 rounded-lg" data-id="element-231">
              <p className="text-2xl md:text-3xl font-heading font-bold text-gold-primary text-center" data-id="element-232">
                Los 3 Hacks del Contribuyente Invisible
              </p>
            </div>
          </div>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-233">
            No son trucos ilegales. No son lagunas oscuras.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed font-semibold text-white" data-id="element-234">
            Son palancas que el sistema ya tiene activadas para ti — y que el
            90% de contribuyentes nunca usa.
          </p>
        </div>
      </div>
    </section>;
}